import { useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import { Footer } from 'components/footer/Footer';
import { Header } from 'components/header/Header';
import { HeaderMobile } from 'components/header/HeaderMobile';

import { useIsMobile } from '@izimi/hooks';

import { Layout } from './Layout';

type Props = {
  withHeader?: boolean;
};

export const AuthenticatedLayout = ({ withHeader = true }: Props = { withHeader: true }) => {
  const isMobile = useIsMobile();

  const header = useMemo(() => {
    if (!withHeader) {
      return null;
    }

    if (isMobile) {
      return <HeaderMobile />;
    }
    return <Header />;
  }, [isMobile, withHeader]);

  const footer = useMemo(() => {
    if (isMobile) {
      return null;
    }

    return <Footer />;
  }, [isMobile]);

  return (
    <Layout header={header} footer={footer}>
      <Outlet />
    </Layout>
  );
};
